var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "dialog-label",
          staticStyle: { "margin-top": "5vh" },
          attrs: {
            title: this.diaTitle,
            visible: _vm.show,
            "modal-append-to-body": false,
            width: "600px",
            height: "400px",
            "close-on-click-modal": false,
            "before-close": _vm.cancelHandle
          },
          on: {
            "update:visible": function($event) {
              _vm.show = $event
            }
          }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 24 } },
            [
              _c("span", { staticClass: "title-tip" }, [_vm._v("标签组名称")]),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      placeholder: "输入关键词",
                      size: "small",
                      clearable: "",
                      maxlength: "15",
                      "show-word-limit": ""
                    },
                    model: {
                      value: _vm.groupName,
                      callback: function($$v) {
                        _vm.groupName = $$v
                      },
                      expression: "groupName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "tags-container", attrs: { gutter: 24 } },
            [
              _c("span", { staticClass: "tag-tip" }, [
                _vm._v("标签"),
                _c(
                  "span",
                  {
                    staticStyle: { color: "#aaaaaa", "font-weight": "normal" }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.groupId != ""
                          ? "（修改标签已使用到该标签的活码、客户信息将同步修改）"
                          : ""
                      )
                    )
                  ]
                )
              ]),
              _c(
                "div",
                {
                  staticStyle: {
                    "max-height": "310px",
                    "overflow-y": "scroll"
                  },
                  attrs: { id: "tagsArea" }
                },
                _vm._l(_vm.dynamicTags, function(item, index) {
                  return _c(
                    "el-col",
                    {
                      key: index,
                      staticStyle: { "margin-top": "10px" },
                      attrs: { span: 24 }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "84%" },
                        attrs: {
                          placeholder: "请输入标签内容",
                          size: "small",
                          clearable: ""
                        },
                        model: {
                          value: _vm.dynamicTags[index].tagName,
                          callback: function($$v) {
                            _vm.$set(_vm.dynamicTags[index], "tagName", $$v)
                          },
                          expression: "dynamicTags[index].tagName"
                        }
                      }),
                      _c(
                        "el-button",
                        {
                          staticStyle: {
                            "border-left": "none",
                            "border-radius": "0 3px 3px 0"
                          },
                          attrs: { size: "small" },
                          on: {
                            click: function($event) {
                              return _vm.delHandle(index)
                            }
                          }
                        },
                        [_vm._v("删 除")]
                      )
                    ],
                    1
                  )
                }),
                1
              ),
              _c(
                "el-button",
                {
                  staticClass: "add-btn",
                  attrs: {
                    type: "primary",
                    size: "mini",
                    icon: "el-icon-plus"
                  },
                  nativeOn: {
                    click: function($event) {
                      return _vm.addTagHanle()
                    }
                  }
                },
                [_vm._v("添加标签")]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      return _vm.cancelHandle()
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function($event) {
                      return _vm.confirmHandle()
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }